import React from 'react';

import { Recommendation } from '../../types'

import {
    Card,
    Clickable,
} from '@fabric-ds/react';

type AdProps = {
    item: Recommendation;
    imagesCdnUrl: string;
}

const JobAd = (props: AdProps) => {
    const {
        item,
        imagesCdnUrl,
    } = props;

    return (
            <Card className="f-card" flat>
                <div aria-owns={item.itemId}></div>
                <div className="flex flex-col">
                    <div className="aspect-w-2 aspect-h-1">
                        <img
                            alt=""
                            className="w-full h-full object-center object-contain m-auto"
                            src={`${imagesCdnUrl}/dynamic/default/${item.image.url}`}
                            style={{maxWidth: '65%', maxHeight: '65%'}}
                        />
                    </div>
                    <div className="bg-bluegray-100">
                        <h4 className="text-gray-700 pt-6 pl-6 pb-32" id={item.itemId}>
                            <Clickable 
                                href={`/${item.itemId}`}
                                className="text-current hover:no-underline focus:no-underline"
                            >
                                {item.heading}
                            </Clickable>
                        </h4>
                        <div>
                            <div className="float-left text-12 absolute bottom-0 left-0 pl-6">
                                {item.content?.company_name}
                            </div>
                            <div className="float-right text-right text-12 absolute bottom-0 right-0 pr-6 pb-6">
                                {item.location?.combined} • {item.content.published_relative}
                            </div>
                        </div>
                    </div>
                </div>
            </Card>
    );
};

export default JobAd;
